module.exports = __webpack_public_path__ + "static/hero-58854316557f9e8eaec44f8de5a7dd79.jpg";